import React from 'react';
// import AmazonPay from 'amazon-pay-react';

import PayWithAppleButton from '../buttons/PayWithAppleButton';
import PayWithPayPalButton from '../buttons/PayWithPayPalButton';
import PayWithAmazonButton from '../buttons/PayWithAmazonButton';

import formStyles from '../styles/styles.module.scss';
// todo: replace this with different implementation
{
  /* <div className={buttonStyles.amazonPay}>
    <AmazonPay
      clientId={amazonClientId}
      sellerId={amazonSellerId}
      agreementType={'BillingAgreement'}
      scope='profile payments:widget'
      btnType='PwA'
      btnColor='Gold'
      btnSize='large'
      onConsentChange={(hasConsent) => console.log(hasConsent) }
      handleBillingAgreementId={amazonPayHandler}
      billingAgreementId={'qwerty'}
      useAmazonAddressBook={false}
    />
  </div> */
}

const ExternalPayForm = ({ text, paypalHandler, applePayHandler, amazonPayHandler, showApplePay, showAmazonPay, amazonClientId, amazonSellerId }) => {
  let applePayDiv;
  if (showApplePay) {
    applePayDiv = (
      <div className={formStyles.inputItem}>
        <PayWithAppleButton text={text.checkoutWith} handler={applePayHandler} />
      </div>
    );
  }

  let amazonPayContent;
  if (showAmazonPay) {
    amazonPayContent = (
      <div className={formStyles.inputItem}>
        <PayWithAmazonButton text={text.checkoutWith} handler={amazonPayHandler} />
      </div>
    );
  }

  return (
    <div>
      <div className={formStyles.inputItem}>
        <PayWithPayPalButton text={text.checkoutWith} handler={paypalHandler} />
      </div>
      {applePayDiv}
      {amazonPayContent}
    </div>
  );
};

export default ExternalPayForm;
